import cn from 'classnames'
import { FC, useEffect, useState } from 'react'

import { SwiperBlock } from 'components/ui/swiper'
import { ICoinPageCurrency } from 'config/coin-pages-list'

import { useTranslation } from 'utils/use-translation'

import { PERCENTAGES } from 'config/constants'

import { slides } from 'pages/home/components/swiper-component/assets/slides'

import {
  ECoinPageParagraphTypes,
  ICoinPageBlogCard,
  ICoinPageData,
  TCoinPageTextElement,
} from '../../assets/page-data/types'

import styles from './styles.module.scss'

const excludedCoins = [
  'lrc',
  'ilv',
  'link',
  'ada',
  'sushi',
  'uni',
  'vet',
  'zrx',
  'sol',
  'dash',
  'mana',
  'trx',
  'ape',
  'hot',
  'aave',
  'ftm',
  'bnb',
  'dot',
  'ltc',
  'mkr',
  'matic',
  'xno',
  'zec',
  'algo',
  'floki',
  'jasmy',
  'volt',
  'bone',
  'kishu',
  'brise',
  'babydoge',
  'quack',
]

export const WhatIsCoin: FC<{
  coinPage: ICoinPageData
  pageCurrency: ICoinPageCurrency
}> = ({ pageCurrency, coinPage }) => {
  const { t, replacePlaceholders } = useTranslation()

  const whatIs = coinPage.whatIs

  const [article, setArticle] = useState('a')

  useEffect(() => setArticle(/^[aeiou]$/i.test(pageCurrency.name[0]) ? 'an' : 'a'), [])

  const renderParagraphs = (list: TCoinPageTextElement[]) => {
    return (
      <ul>
        {list.map((item, index) => (
          <li
            key={`text-${index}`}
            className={styles.paragraph}
            dangerouslySetInnerHTML={{
              __html: t(item).includes('{PERCENTAGES.loan}')
                ? String(replacePlaceholders(t(item), { 'PERCENTAGES.loan': PERCENTAGES.loan }))
                : String(t(item)),
            }}
          />
        ))}
      </ul>
    )
  }

  const renderList = (list: TCoinPageTextElement[]) => {
    return (
      <ul>
        {list.map((item, index) => (
          <li
            className={styles.listItem}
            key={`item-${index}`}
            dangerouslySetInnerHTML={{
              __html: t(item).includes('{PERCENTAGES.loan}')
                ? String(replacePlaceholders(t(item), { 'PERCENTAGES.loan': PERCENTAGES.loan }))
                : String(t(item)),
            }}
          />
        ))}
      </ul>
    )
  }

  const renderCards = (list: ICoinPageBlogCard[]) => {
    return list.map((item, index) => (
      <a href={item.link} key={index} target="_blank" rel="noopener noreferrer">
        <img src={item.image} alt={item.imageAlt} />
      </a>
    ))
  }

  return (
    <div
      className={cn(
        styles.container,
        excludedCoins.includes(pageCurrency.code) && pageCurrency?.missWhatIsCoin && styles.emptyContainer,
      )}
    >
      {slides && (
        <div className={styles.wrapper}>
          <SwiperBlock
            title={`${pageCurrency?.customFields?.communityHeading || pageCurrency.name} ${t('community_trusts_us')}`}
            slides={slides}
          />
        </div>
      )}

      {whatIs.text.length !== 0 && !excludedCoins.includes(pageCurrency.code) && !pageCurrency?.missWhatIsCoin && (
        <div className={cn('container', styles.coinContent)}>
          <h2>{`What is ${article} ${pageCurrency.customFields?.whatIsCoinName || pageCurrency.name} Loan?`}</h2>
          {renderParagraphs(whatIs.text)}
        </div>
      )}

      <div className={cn('container', styles.coinContent)}>
        {whatIs.paragraphs &&
          whatIs.paragraphs.map((par) => (
            <div key={par.title}>
              <h2>{t(par.title)}</h2>
              {par.type === ECoinPageParagraphTypes.ul && renderList(par.text)}
              {!par.type && renderParagraphs(par.text)}
            </div>
          ))}

        {whatIs?.blogCards && <>
          <h2>
            {whatIs?.learnMoreTitle ? replacePlaceholders(t('learn_more_about_name_lending'), {
              name: pageCurrency.name
            }) : `${t('learn_more_about')} ${pageCurrency.name} ${t('loans')}`}
          </h2>
          <div className={styles.cards}>{renderCards(whatIs.blogCards)}</div>
        </>}
      </div>
    </div>
  )
}
